import { useEffect, useState } from "react";
import axios from "axios";

const base_url = process.env.REACT_APP_API_URL;

export default function Dashboard() {

  const token = localStorage.getItem("admin_token");

  const [stats,setStats] = useState({
    totalUsers:0,
    totalDeposit:0,
    totalWithdraw:0,
    totalBet:0,
    totalWin:0,
    depositProfit:0,
    betProfit:0
  });

  const fetchDashboard = async () => {

    const res = await axios.get(
      `${base_url}/api/admin/dashboard`,
      { headers:{ Authorization:token }}
    );

    if(res.data.success){
      setStats(res.data.data);
    }

  };

  useEffect(()=>{
    fetchDashboard();
  },[]);

  return (
    <div className="px-4">

      <h4 className="mb-4">Dashboard</h4>

      <div className="row g-4">

        <div className="col-md-3">
          <div className="card p-3 shadow-sm bg-dark text-white">
            <h6>Total Users</h6>
            <h3>{stats.totalUsers}</h3>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card p-3 shadow-sm bg-primary text-white">
            <h6>Total Users Balance</h6>
            <h3>{parseFloat(stats.totalUsersBalance).toFixed(2)}</h3>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card p-3 shadow-sm bg-success text-white">
            <h6>Total Deposit</h6>
            <h3>₹{stats.totalDeposit}</h3>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card p-3 shadow-sm bg-danger text-white">
            <h6>Total Withdraw</h6>
            <h3>₹{stats.totalWithdraw}</h3>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card p-3 shadow-sm bg-primary text-white">
            <h6>Deposit Profit</h6>
            <h3>₹{stats.depositProfit}</h3>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card p-3 shadow-sm bg-dark text-white">
            <h6>Total Bet</h6>
            <h3>₹{stats.totalBet}</h3>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card p-3 shadow-sm bg-warning text-dark">
            <h6>Total Win</h6>
            <h3>₹{stats.totalWin}</h3>
          </div>
        </div>

        <div className="col-md-3">
          <div className={`card p-3 shadow-sm ${stats.betProfit >= 0 ? "bg-success" : "bg-danger"} text-white`}>
            <h6>Bet Profit / Loss</h6>
            <h3>₹{stats.betProfit}</h3>
          </div>
        </div>

      </div>

    </div>
  );
}